'use client';

import { Input as HeroInput, type InputProps as HeroInputProps } from '@heroui/react';
import * as React from 'react';

export interface InputProps extends Omit<HeroInputProps, 'color'> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ type = 'text', variant = 'bordered', ...props }, ref) => {
    return <HeroInput ref={ref} type={type} variant={variant} {...props} />;
  }
);
Input.displayName = 'Input';

export { Input };
